import React from "react";
import PropTypes from "prop-types";
import SettingsButton from "./SettingsButton";
import PlaceMenu from "./PlaceMenu";
import AddButton from "./AddButton";

import "./style.scss";

/**
 * @return {null}
 */
function PlacebarMenu({itemLabel, selected, items, disabled, parent}) {
  if (!items) {
    return null;
  }

  let newChildPath = parent ? `/facilities/${parent && parent.getNewChildPath()}` : "/facilities";
  let settingsPath = selected && `/facilities/${selected.getPath()}`;
  return (
    <div className={`placebarItem ${itemLabel}BarItem`}>
      <PlaceMenu disabled={disabled} itemLabel={itemLabel} selected={selected} parent={parent} items={items} />
      <div className="controls">
        <AddButton to={newChildPath} disabled={disabled} />
        <SettingsButton to={settingsPath} />
      </div>
    </div>
  );
}

PlacebarMenu.propTypes = {
  itemLabel: PropTypes.string.isRequired,
  selected: PropTypes.object,
  items: PropTypes.array,
  parent: PropTypes.object,
  disabled: PropTypes.bool
};

PlacebarMenu.defaultProps = {
  disabled: false
};

export default PlacebarMenu;



// WEBPACK FOOTER //
// ./src/components/Placebar/components/PlacebarMenu/index.jsx